export default [
  {
    "id": "mat-enem-0343",
    "numero": 1843,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "A figura a seguir apresenta dois gráficos com \ninformações sobre as reclamações diárias rece-\nbidas e resolvidas pelo Setor de Atendimento ao \nCliente (SAC) de uma empresa, em uma dada \nsemana. O gráfico de linha tracejada informa o \nnúmero de reclamações recebidas no dia, o de \nlinha contínua é o número de reclamações re-\nsolvidas no dia. As reclamações podem ser \nresolvidas no mesmo dia ou demorarem mais \nde um dia para serem resolvidas. \n \n \n \nO gerente de atendimento deseja identificar os \ndias da semana em que o nível de eficiência \npode ser considerado muito bom, ou seja, os \ndias em que o número de reclamações resolvi-\ndas excede o número de reclamações recebi-\ndas. \n \nO gerente de atendimento pôde concluir, base-\nado no conceito de eficiência utilizado na em-\npresa e nas informações do gráfico, que o nível \nde eficiência foi muito bom na: \n \nA) segunda e na terça-feira. \nB) terça e na quarta-feira. \nC) terça e na quinta-feira. \nD) quinta-feira, no sábado e no domingo. \nE) segunda, na quinta e na sexta-feira.",
    "alternativas": {
      "B": "terça e na quarta-feira.",
      "C": "terça e na quinta-feira.",
      "E": "segunda, na quinta e na sexta-feira.",
      "A": "segunda e na terça-feira."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 343,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0344",
    "numero": 1844,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Uma mãe recorreu à bula para verificar a dosa-\ngem de um remédio que precisava dar a seu \nfilho. Na bula, recomendava-se a seguinte do-\nsagem: 5 gotas para cada 2 kg de massa corpo-\nral a cada 8 horas. \n \nSe a mãe ministrou corretamente 30 gotas do \nremédio a seu filho a cada 8 horas, então a \nmassa corporal dele é de: \n \nA) 12 kg. \nB) 16 kg. \nC) 24 kg. \nD) 36 kg. \nE) 75 kg.",
    "alternativas": {
      "D": "36 kg.",
      "A": "12 kg.",
      "B": "16 kg.",
      "C": "24 kg."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 344,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0346",
    "numero": 1846,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "As curvas de oferta e de demanda de um produ-\nto representam, respectivamente, as quantida-\ndes que vendedores e consumidores estão dis-\npostos a comercializar em função do preço do \nproduto. Em alguns casos, essas curvas podem \nser representadas por retas. Suponha que as \nquantidades de oferta e de demanda de um \nproduto sejam, respectivamente, representadas \npelas equações: \n \nQO = –20 + 4P \nQD = 46 – 2P \n \nEm que QO é quantidade de oferta, QD é a quan-\ntidade de demanda e P é o preço do produto. \n \nA partir dessas equações, de oferta e de de-\nmanda, os economistas encontram o preço de \nequilíbrio de mercado, ou seja, quando QO e QD \nse igualam. Para a situação descrita, qual o \nvalor do preço de equilíbrio? \n \nA) 5 \nB) 11 \nC) 13 \nD) 23 \nE) 33",
    "alternativas": {
      "A": "5",
      "B": "11",
      "D": "23",
      "E": "33"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 346,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0347",
    "numero": 1847,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Nos shopping centers costumam existir parques \ncom vários brinquedos e jogos. Os usuários \ncolocam créditos em um cartão, que são des-\ncontados por cada período de tempo de uso dos \njogos. Dependendo da pontuação da criança no \njogo, ela recebe um certo número de tíquetes \npara trocar por produtos nas lojas dos parques. \n \nSuponha que o período de uso de um brinquedo \nem certo shopping custa R$ 3,00 e que uma \nbicicleta custa 9 200 tíquetes. Para uma criança \nque recebe 20 tíquetes por período de tempo \nque joga, o valor, em reais, gasto com créditos \npara obter a quantidade de tíquetes para trocar \npela bicicleta é: \n \nA) 153. \nB) 460. \nC) 1218. \nD) 1380. \nE) 3066.",
    "alternativas": {
      "A": "153.",
      "B": "460.",
      "D": "1380.",
      "E": "3066."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 347,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0348",
    "numero": 1848,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Dentre outros objetos de pesquisa, a Alometria \nestuda a relação entre medidas de diferentes \npartes do corpo humano. Por exemplo, segundo \na Alometria, a área A da superfície corporal de \numa pessoa relaciona-se com a sua massa m \npela fórmula A = k.m2/3, em que k é uma cons-\ntante positiva. \nSe no período que vai da infância até a maiori-\ndade de um indivíduo sua massa é multiplicada \npor 8, por quanto será multiplicada a área da \nsuperfície corporal? \n \nA) √16\n3\n \nB) 4 \nC) √24 \nD) 8 \nE) 64",
    "alternativas": {
      "C": "√24",
      "E": "64",
      "A": "√16 3",
      "B": "4"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 348,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0351",
    "numero": 1851,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Em 20 de fevereiro de 2011 ocorreu a grande \nerupção do vulcão Bulusan nas Filipinas. A sua \nlocalização geográfica no globo terrestre é dada \npelo GPS (sigla em inglês para Sistema de Po-\nsicionamento Global) com longitude de 124° 3’ \n0” a leste do Meridiano de Greenwich. \n \nDado: 1° equivale a 60’ e 1’ equivale a 60”. \n \nA representação angular da localização do vul-\ncão com relação a sua longitude na forma deci-\nmal é: \n \nA) 124,02°. \nB) 124,05°. \nC) 124,20°. \nD) 124,30°. \nE) 124,50°.",
    "alternativas": {
      "B": "124,05°.",
      "D": "124,30°.",
      "E": "124,50°.",
      "A": "124,02°."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 351,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0352",
    "numero": 1852,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "A Agência Espacial Norte Americana (NASA) \ninformou que o asteroide YU 55 cruzou o espa-\nço entre a Terra e a Lua no mês de novembro \nde 2011. A ilustração a seguir sugere que o \nasteroide percorreu sua trajetória no mesmo \nplano que contém a órbita descrita pela Lua em \ntorno da Terra. Na figura, está indicada a proxi-\nmidade do asteroide em relação à Terra, ou \nseja, a menor distância que ele passou da su-\nperfície terrestre. \n \n \n \nCom base nessas informações, a menor distân-\ncia que o asteroide YU 55 passou da superfície \nda Terra é igual a: \n \nA) 3,25 × 102 km. \nB) 3,25 × 103 km. \nC) 3,25 × 104 km. \nD) 3,25 × 105 km. \nE) 3,25 × 106 km.",
    "alternativas": {
      "B": "3,25 × 103 km.",
      "D": "3,25 × 105 km.",
      "E": "3,25 × 106 km.",
      "A": "3,25 × 102 km."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 352,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0353",
    "numero": 1853,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Há, em virtude da demanda crescente de eco-\nnomia de água, equipamentos e utensílios co-\nmo, por exemplo, as bacias sanitárias ecológi-\ncas, que utilizam 6 litros de água por descarga \nem vez dos 15 litros utilizados por bacias sanitá-\nrias não ecológicas, conforme dados da Associ-\nação Brasileira de Normas Técnicas (ABNT). \n \nQual será a economia diária de água obtida por \nmeio da substituição de uma bacia sanitária não \necológica, que gasta cerca de 60 litros por dia \ncom a descarga, por uma bacia sanitária ecoló-\ngica? \n \nA) 24 litros \nB) 36 litros \nC) 40 litros \nD) 42 litros \nE) 50 litros",
    "alternativas": {
      "E": "50 litros",
      "A": "24 litros",
      "B": "36 litros",
      "C": "40 litros"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 353,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0354",
    "numero": 1854,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "A tabela a seguir mostra a evolução da receita \nbruta anual nos três últimos anos de cinco mi-\ncroempresas (ME) que se encontram à venda. \n \n \n \nUm investidor deseja comprar duas das empre-\nsas listadas na tabela. Para tal, ele calcula a \nmédia da receita bruta anual dos últimos três \nanos (de 2009 até 2011) e escolhe as duas \nempresas de maior média anual. As empresas \nque este investidor escolhe comprar são: \n \nA) Balas W e Pizzaria Y. \nB) Chocolates X e Tecelagem Z. \nC) Pizzaria Y e Alfinetes V. \nD) Pizzaria Y e Chocolates X. \nE) Tecelagem Z e Alfinetes V.",
    "alternativas": {
      "C": "Pizzaria Y e Alfinetes V.",
      "D": "Pizzaria Y e Chocolates X.",
      "A": "Balas W e Pizzaria Y.",
      "B": "Chocolates X e Tecelagem Z."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 354,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0355",
    "numero": 1855,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Um produtor de café irrigado em Minas Gerais \nrecebeu um relatório de consultoria estatística, \nconstando, entre outras informações, o desvio \npadrão das produções de uma safra dos talhões \nde sua propriedade. Os talhões têm a mesma \nárea de 30 000 m2 e o valor obtido para o desvio \npadrão foi de 90 kg/talhão. O produtor deve \napresentar as informações sobre a produção e a \nvariância dessas produções em sacas de 60 kg \npor hectare (10 000 m2). \n \nA variância das produções dos talhões expressa \nem (sacas/hectare)2 é: \n \nA) 20,25. \nB) 4,50. \nC) 0,71. \nD) 0,50. \nE) 0,25.",
    "alternativas": {
      "E": "0,25.",
      "B": "4,50.",
      "C": "0,71.",
      "D": "0,50."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 355,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0356",
    "numero": 1856,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Um laboratório realiza exames em que é possí-\nvel observar a taxa de glicose de uma pessoa. \nOs resultados são analisados de acordo com o \nquadro a seguir. \n \n \n \nUm paciente fez um exame de glicose nesse \nlaboratório e comprovou que estava com hiper-\nglicemia. Sua taxa de glicose era de 300 mg/dL. \nSeu médico prescreveu um tratamento em duas \netapas. Na primeira etapa ele conseguiu reduzir \nsua taxa em 30% e na segunda etapa em 10%. \n \nAo calcular sua taxa de glicose após as duas \nreduções, o paciente verificou que estava na \ncategoria de: \n \nA) hipoglicemia. \nB) normal. \nC) pré-diabetes. \nD) diabetes melito. \nE) hiperglicemia.",
    "alternativas": {
      "C": "pré-diabetes.",
      "D": "diabetes melito.",
      "E": "hiperglicemia.",
      "A": "hipoglicemia."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 356,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0357",
    "numero": 1857,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O designer português Miguel Neiva criou um \nsistema de símbolos que permite que pessoas \ndaltônicas identifiquem cores. O sistema consis-\nte na utilização de símbolos que identificam as \ncores primárias (azul, amarelo e vermelho). \nAlém disso, a justaposição de dois desses sím-\nbolos permite identificar cores secundárias (co-\nmo o verde, que é o amarelo combinado com o \nazul). O preto e o branco são identificados por \npequenos quadrados: o que simboliza o preto é \ncheio, enquanto o que simboliza o branco é \nvazio. Os símbolos que representam preto e \nbranco também podem estar associados aos \nsímbolos que identificam cores, significando se \nestas são claras ou escuras.  \nDe acordo com o texto, quantas cores podem \nser representadas pelo sistema proposto? \n \nA) 14 \nB) 18 \nC) 20 \nD) 21 \nE) 23",
    "alternativas": {
      "C": "20",
      "E": "23",
      "A": "14",
      "B": "18"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 357,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0358",
    "numero": 1858,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "José, Paulo e Antônio estão jogando dados não \nviciados, nos quais, em cada uma das seis fa-\nces, há um número de 1 a 6. Cada um deles \njogará dois dados simultaneamente. José acre-\ndita que, após jogar seus dados, os números \ndas faces voltadas para cima lhe darão uma \nsoma igual a 7. Já Paulo acredita que sua soma \nserá igual a 4 e Antônio acredita que sua soma \nserá igual a 8.  \n \nCom essa escolha, quem tem a maior probabili-\ndade de acertar sua respectiva soma é: \n \nA) Antônio, já que sua soma é a maior de todas \nas escolhidas. \nB) José e Antônio, já que há 6 possibilidades \ntanto para a escolha de José quanto para a \nescolha de Antônio, e há apenas 4 possibilida-\ndes para a escolha de Paulo. \nC) José e Antônio, já que há 3 possibilidades \ntanto para a escolha de José quanto para a \nescolha de Antônio, e há apenas 2 possibilida-\ndes para a escolha de Paulo. \nD) José, já que há 6 possibilidades para formar \nsua soma, 5 possibilidades para formar a soma \nde Antônio e apenas 3 possibilidades para for-\nmar a soma de Paulo. \nE) Paulo, já que sua soma é a menor de todas.",
    "alternativas": {
      "C": "José e Antônio, já que há 3 possibilidades tanto para a escolha de José quanto para a escolha de Antônio, e há apenas 2 possibilida- des para a escolha de Paulo.",
      "D": "José, já que há 6 possibilidades para formar sua soma, 5 possibilidades para formar a soma de Antônio e apenas 3 possibilidades para for- mar a soma de Paulo.",
      "A": "Antônio, já que sua soma é a maior de todas as escolhidas.",
      "B": "José e Antônio, já que há 6 possibilidades tanto para a escolha de José quanto para a escolha de Antônio, e há apenas 4 possibilida- des para a escolha de Paulo."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 358,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0359",
    "numero": 1859,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "A cerâmica possui a propriedade da contração, \nque consiste na evaporação da água existente \nem um conjunto ou bloco cerâmico submetido a \numa determinada temperatura elevada: em seu \nlugar aparecendo “espaços vazios” que tendem \na se aproximar. No lugar antes ocupado pela \nágua vão ficando lacunas e, consequentemente, \no conjunto tende a retrair-se.  \n \nConsidere que no processo de cozimento a \ncerâmica de argila sofra uma contração, em \ndimensões lineares, de 20%. Levando em con-\nsideração o processo de cozimento e a contra-\nção sofrida, o volume V de uma travessa de \nargila, de forma cúbica de aresta a, diminui para \num valor que é: \n \nA) 20% menor que V, uma vez que o volume do \ncubo é diretamente proporcional ao comprimen-\nto de seu lado. \nB) 36% menor que V, porque a área da base diminui de a2 para ((1 − 0,2)a)2. \nC) 48,8% menor que V, porque o volume diminui de a3 para (0,8a)3. \nD) 51,2% menor que V, porque cada lado diminui para 80% do comprimento original. \nE) 60% menor que V, porque cada lado diminui 20%.",
    "alternativas": {
      "A": "20% menor que V, uma vez que o volume do cubo é diretamente proporcional ao comprimen- to de seu lado.",
      "B": "36% menor que V, porque a área da base diminui de a2 para ((1 − 0,2)a)2.",
      "C": "48,8% menor que V, porque o volume diminui de a3 para (0,8a)3.",
      "D": "51,2% menor que V, porque cada lado diminui para 80% do comprimento original."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 359,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0360",
    "numero": 1860,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O gráfico apresenta o comportamento de emprego formal surgido, segundo o Caged, no período de ja-\nneiro de 2010 a outubro de 2010. \n \nBrasil - Comportamento do Emprego Formal  \nno período de janeiro a outubro de 2010 - CAGED \n \n \nCom base no gráfico, o valor da parte inteira da mediana dos empregos formais surgidos no período é: \n \nA) 212 952. \nB) 229 913. \nC) 240 621. \nD) 255 496. \nE) 298 041.",
    "alternativas": {
      "E": "298 041.",
      "B": "229 913.",
      "C": "240 621.",
      "D": "255 496."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 360,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0361",
    "numero": 1861,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "A figura apresenta a eficiência, a vida útil (mil horas) e o preço médio (R$) dos modelos de lâmpadas \nmais usados em residências. \n \n \n \nConsidere que, para iluminar dois ambientes com a mesma eficiência, é necessário que ambos tenham a \nmesma quantidade de lúmens por Watt, independentemente da quantidade de lâmpadas. \n \nConsidere também que a relação custo/benefício de qualquer uma dessas lâmpadas é dada pela razão \nentre o preço médio (R$) e a vida útil (mil horas). Augusto deseja instalar lâmpadas em um dos ambien-\ntes de sua casa, de modo a obter uma eficiência de exatamente 240 lúmens por Watt. \n \nDos modelos de lâmpadas apresentados na figura, o que atende a necessidade de Augusto com a me-\nnor relação custo/benefício é: \n \n \nA) LED. \nB) fluorescente compacta. \nC) incandescente. \nD) halógena. \nE) fluorescente.",
    "alternativas": {
      "C": "incandescente.",
      "D": "halógena.",
      "E": "fluorescente.",
      "A": "LED."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 361,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0362",
    "numero": 1862,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "A tabela seguinte apresenta a média, em kg, de \nresíduos domiciliares produzidos anualmente \npor habitante, no período de 1995 a 2005. \n \nProdução de resíduos domiciliares  \npor habitante em um país \n  \n \n \nSe essa produção continuar aumentando, man-\ntendo o mesmo padrão observado na tabela, a \nprevisão de produção de resíduos domiciliares, \npor habitante no ano de 2020, em kg, será: \n \n \nA) 610. \nB) 700. \nC) 640. \nD) 710. \nE) 660.",
    "alternativas": {
      "D": "710.",
      "E": "660.",
      "A": "610.",
      "B": "700."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 362,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0363",
    "numero": 1863,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Cinco times de futebol (A, B, C, D e E) ocupa-\nram as primeiras colocações em um campeona-\nto realizado em seu país. A classificação final \ndesses clubes apresentou as seguintes caracte-\nrísticas: \n \n• O time A superou o time C na classificação; \n• O time C ficou imediatamente à frente do time E; \n• O time B não ficou entre os 3 últimos colocados; \n• O time D ficou em uma classificação melhor que \na do time A. \n \nAssim, os dois times mais bem classificados \nforam: \n \n \nA) B e D. \nB) B e E. \nC) A e C. \nD) C e D. \n \nE) A e B.",
    "alternativas": {
      "C": "A e C.",
      "E": "A e B.",
      "A": "B e D.",
      "B": "B e E."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 363,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0364",
    "numero": 1864,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O consumo de energia elétrica, nos últimos \nmeses, na casa de uma família, é mostrado nas \nseguintes tabelas. \n \n \nA média do consumo mensal de energia elétrica \nna casa dessa família, de setembro de 2011 a \nfevereiro de 2012, é: \n \nA) 282. \nB) 280. \nC) 288. \nD) 292. \nE) 284.",
    "alternativas": {
      "D": "292.",
      "A": "282.",
      "B": "280.",
      "C": "288."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 364,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0365",
    "numero": 1865,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "A noz é uma especiaria muito apreciada nas \nfestas de fim de ano. Uma pesquisa de preços \nfeita em três supermercados obteve os seguin-\ntes valores: no supermercado A é possível \ncomprar nozes a granel no valor de R$ 24,00 o \nquilograma; o supermercado B vende embala-\ngens de nozes hermeticamente fechadas com \n250 gramas a R$ 3,00; já o supermercado C \nvende nozes a granel a R$ 1,50 cada 100 gra-\nmas. \n \nA sequência dos supermercados, de acordo \ncom a ordem crescente do valor da noz, é: \n \nA) C, A, B. \nB) B, C, A. \nC) B, A, C. \nD) C, B, A. \nE) A, B, C.",
    "alternativas": {
      "B": "B, C, A.",
      "C": "B, A, C.",
      "D": "C, B, A.",
      "E": "A, B, C."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 365,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0366",
    "numero": 1866,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Acidentes banais como escorregões, quedas e \ntropeços se tornaram a segunda maior causa de \nmorte na humanidade. A tabela a seguir mostra \nalguns tipos de acidentes e sua incidência, em \nmilhares, no ano de 2009, nos EUA. \n \n \n \nConsiderando os dados apresentados, a média \nde machucados em 2009, em milhares, nos \nEUA, foi igual a: \n \n \nA) 268. \nB) 300. \nC) 330. \nD) 200. \nE) 290.",
    "alternativas": {
      "D": "200.",
      "E": "290.",
      "A": "268.",
      "C": "330."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 366,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0367",
    "numero": 1867,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O Brasil é um dos maiores produtores de leite \ndo mundo. Em 2010 para a produção de 30,7 \nbilhões de litros de leite foram ordenhadas 22,9 \nmilhões de vacas leiteiras em todo o país, sen-\ndo que essa quantidade de vacas ordenhadas \nrepresenta 10,9% do rebanho brasileiro de bo-\nvinos. \n \nNessas condições, o número que mais se apro-\nxima da quantidade de bovinos no Brasil em \n2010, em milhões de unidades, é: \n \n \nA) 281,65. \n \nB) 187,19. \nC) 210,09. \n \nD) 25,40. \nE) 33,80.",
    "alternativas": {
      "A": "281,65.",
      "B": "187,19.",
      "C": "210,09.",
      "E": "33,80."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 367,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0368",
    "numero": 1868,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O Ministério da Saúde acompanha com preocu-\npação a difusão da tuberculose no Brasil. Um \nsistema de vigilância baseia-se no acompanha-\nmento sistemático das taxas de incidência des-\nsa doença nos estados. Depois de credenciar \nalguns estados a receberem recursos, em 2006, \npassou a ser de grande importância definir prio-\nridades para a alocação de recursos de comba-\nte e prevenção, levando em consideração as \ntaxas de incidência para os anos de 2000 e \n2004, conforme o quadro seguinte. \n \n \n \nSe a prioridade na distribuição de recursos for \ndada ao estado que tiver maior aumento absolu-\nto em suas taxas de incidência, ela será dada \npara: \n \n \nA) Amapá. \nB) Amazonas. \nC) Minas Gerais. \nD) Rio de Janeiro. \nE) Pernambuco.",
    "alternativas": {
      "E": "Pernambuco.",
      "A": "Amapá.",
      "B": "Amazonas.",
      "C": "Minas Gerais."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 368,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0369",
    "numero": 1869,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Em uma aula de matemática, a professora pro-\npôs que os alunos construíssem um cubo a \npartir da planificação em uma folha de papel, \nrepresentada na figura a seguir. \n \n \nApós a construção do cubo, apoiou-se sobre a \nmesa a face com a letra M. As faces paralelas \ndeste cubo são representadas pelos pares de \nletras: \n \n \nA) B-N, E-E e M-R. \nB) E-M, B-N e E-R. \nC) B-E, E-R e M-N. \nD) E-N, B-M e E-R. \nE) E-N, E-M e B-R.",
    "alternativas": {
      "D": "E-N, B-M e E-R.",
      "A": "B-N, E-E e M-R.",
      "B": "E-M, B-N e E-R.",
      "C": "B-E, E-R e M-N."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 369,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0370",
    "numero": 1870,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma churrascaria cobra, no almoço, R$ 12,00 \npor pessoa. Após às 15 h, esse valor cai para \nR$ 9,00. Estima-se que o custo total de um al-\nmoço seja de R$ 7,00 por pessoa. Em média, \npor dia, almoçam na churrascaria 1 000 clientes, \nsendo que 3/4 deles comparecem até às 15 h. \n \nQual o lucro médio, por dia, da churrascaria? \n \n \nA) R$ 2250,00 \nB) R$ 4250,00 \nC) R$ 3750,00 \nD) R$ 7000,00 \nE) R$ 9000,00",
    "alternativas": {
      "C": "R$ 3750,00",
      "D": "R$ 7000,00",
      "E": "R$ 9000,00",
      "B": "R$ 4250,00"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 370,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0371",
    "numero": 1871,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Em uma floresta, existem 4 espécies de insetos, \nA, B, C e P, que têm um ciclo de vida semelhan-\nte. Essas espécies passam por um período, em \nanos, de desenvolvimento dentro de seus casu-\nlos. Durante uma primavera, elas saem, põem \nseus ovos para o desenvolvimento da próxima \ngeração e morrem. \n \nSabe-se que as espécies A, B e C se alimentam \nde vegetais e a espécie P é predadora das ou-\ntras 3. Além disso, a espécie P passa 4 anos \nem desenvolvimento dentro dos casulos, já a \nespécie A passa 8 anos, a espécie B passa 7 \nanos e a espécie C passa 6 anos. \n \nAs espécies A, B e C só serão ameaçadas de \nextinção durante uma primavera pela espécie P, \nse apenas uma delas surgirem na primavera \njunto com a espécie P. \n \nNessa primavera atual, todas as 4 espécies \nsaíram dos casulos juntas. \nQual será a primeira e a segunda espécies a \nserem ameaçadas de extinção por surgirem \nsozinhas com a espécie predadora numa próxi-\nma primavera? \n \nA) A primeira a ser ameaçada é a espécie C e a \nsegunda é a espécie A. \nB) A primeira a ser ameaçada é a espécie A e a \nsegunda é a espécie C.  \nC) A primeira a ser ameaçada é a espécie C e a \nsegunda é a espécie B. \nD) A primeira a ser ameaçada é a espécie A e a \nsegunda é a espécie B. \nE) A primeira a ser ameaçada é a espécie B e a \nsegunda é a espécie C.",
    "alternativas": {
      "D": "A primeira a ser ameaçada é a espécie A e a segunda é a espécie B.",
      "E": "A primeira a ser ameaçada é a espécie B e a segunda é a espécie C.",
      "A": "A primeira a ser ameaçada é a espécie C e a segunda é a espécie A.",
      "C": "A primeira a ser ameaçada é a espécie C e a segunda é a espécie B."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 371,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0372",
    "numero": 1872,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Um reservatório de uma cidade estava com \n30m3 de água no momento em que iniciou um \nvazamento estimado em 30 litros por minuto.  \n \nDepois de 20 minutos, a partir do início do va-\nzamento, uma equipe técnica chegou ao local e \ngastou exatamente 2 horas para consertar o \nsistema e parar o vazamento. O reservatório \nnão foi reabastecido durante todo o período que \nesteve com o vazamento. \n \nQual foi o volume de água que sobrou no reser-\nvatório, em m3, no momento em que parou o \nvazamento? \n \n \nA) 4,2 \nB) 26,4 \nC) 25,8 \nD) 3,6 \nE) 27,6",
    "alternativas": {
      "D": "3,6",
      "E": "27,6",
      "A": "4,2",
      "B": "26,4"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 372,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0373",
    "numero": 1873,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma pesquisa foi realizada com a intenção de \nconhecer o que as pessoas sabem sobre o dia-\nbetes. Nela, utilizou-se um questionário com 16 \nperguntas, respondidas pelas pessoas na en-\ntrada de estações do metrô de São Paulo. Os \ngráficos a seguir mostram, respectivamente, os \npercentuais de respostas dadas às seguintes \nperguntas do questionário: “Você conhece al-\nguém com diabetes?” e “Caso conheça, indique \nonde.” \n \n \n \n \n \nO percentual do número de entrevistados que \nconhecem pessoas diabéticas na escola é mais \naproximado por: \n \nA) 37%. \n \nB) 15%. \nC) 52%. \nD) 6%. \nE) 41%.",
    "alternativas": {
      "B": "15%.",
      "C": "52%.",
      "D": "6%.",
      "A": "37%."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 373,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0374",
    "numero": 1874,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma coleta de dados em mais de 5 mil sites da \ninternet apresentou os conteúdos de interesse \nde cada faixa etária. Na tabela a seguir estão os \ndados obtidos para a faixa etária de 0 a 17 \nanos. \n \n \n \n* Serviços web: aplicativos on-line, emoticons, \nmensagens para redes sociais, entre outros. \n \n** Sites sobre vestibular, ENEM, páginas com \nmaterial de pesquisa escolar. \n \nConsidere que esses dados refletem os interes-\nses dos brasileiros desta faixa etária. \n \nSelecionando, ao acaso, uma pessoa desta \nfaixa etária, a probabilidade de que ela não te-\nnha preferência por horóscopo é: \n \nA) 0,91. \nB) 0,09. \nC) 0,11. \nD) 0,10. \nE) 0,79.",
    "alternativas": {
      "B": "0,09.",
      "C": "0,11.",
      "D": "0,10.",
      "A": "0,91."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 374,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0375",
    "numero": 1875,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O sistema de numeração romana, hoje em de-\nsuso, já foi o principal sistema de numeração da \nEuropa. Nos dias atuais, a numeração romana é \nusada no nosso cotidiano essencialmente para \ndesignar os séculos, mas já foi necessário fazer \ncontas e descrever números bastante grandes \nnesse sistema de numeração. Para isto, os ro-\nmanos colocavam um traço sobre o número \npara representar que esse número deveria ser \nmultiplicado por 1 000. Por exemplo, o número X̅ \nrepresenta o número 10 × 1000, ou seja, 10000. \n \nDe acordo com essas informações, os números \nMCCV\n̅̅̅̅̅̅̅̅ e XLII\n̅̅̅̅̅ são, respectivamente, iguais a W: \n \nA) 1205000 e 493000. \nB) 1205000 e 63000. \nC) 1250000 e 63000. \nD) 1250000 e 43000. \nE) 1205000 e 43000.",
    "alternativas": {
      "E": "1205000 e 43000.",
      "B": "1205000 e 63000.",
      "C": "1250000 e 63000.",
      "D": "1250000 e 43000."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 375,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0376",
    "numero": 1876,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Alguns países têm regulamentos que obrigam a \nmisturar 5%, 10% ou 20% de etanol com a ga-\nsolina regular. Esta mistura recebe o nome de \ngasool. E20, por exemplo, é o gasool que con-\ntém a mistura de 20% de etanol com 80% de \ngasolina. Em agosto de 2011, o governo decidiu \nreduzir a mistura de etanol na gasolina de 25% \npara 20%, isto é, nossos postos de gasolina, a \npartir daquele mês, não puderam mais vender o \ncombustível do tipo E25. \n \nUma distribuidora possuía 40 mil litros de com-\nbustível do tipo E25, disponíveis em um dos \ntanques de seu estoque antigo. Quantos litros \nde gasolina precisam ser adicionados de modo \na obter uma mistura E20? \n \n \nA) 2000 \nB) 10000 \nC) 16000 \nD) 8000 \nE) 32000",
    "alternativas": {
      "D": "8000",
      "E": "32000",
      "A": "2000",
      "B": "10000"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 376,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0377",
    "numero": 1877,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O apresentador de um programa de auditório \npropôs aos participantes de uma competição a \nseguinte tarefa: cada participante teria 10 minu-\ntos para recolher moedas douradas colocadas \naleatoriamente em um terreno destinado à reali-\nzação da competição. A pontuação dos compe-\ntidores seria calculada ao final do tempo desti-\nnado a cada um dos participantes, no qual as \nmoedas coletadas por eles seriam contadas e a \npontuação de cada um seria calculada, subtra-\nindo do número de moedas coletadas uma por-\ncentagem de valor igual ao número de moedas \ncoletadas. Dessa forma, um participante que \ncoletasse 60 moedas teria sua pontuação calcu-\nlada da seguinte forma: pontuação = 60 – 36 \n(60% de 60) = 24. O vencedor da prova seria o \nparticipante que alcançasse a maior pontuação. \n \nQual será o limite máximo de pontos que um \ncompetidor pode alcançar nessa prova? \n \nA) 50 \nB) 75 \nC) 0 \nD) 100 \nE) 25",
    "alternativas": {
      "B": "75",
      "D": "100",
      "E": "25",
      "A": "50"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 377,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0378",
    "numero": 1878,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Um jornaleiro irá receber 21 revistas. Cada uma \nterá um carrinho na escala de 1:43 do tamanho \nreal acompanhando-a em caixinha à parte. Os \ncarrinhos são embalados com folga de 0,5 cm \nnas laterais, como indicado na figura. Assim, o \njornaleiro reservou três prateleiras com 95 cm \nde comprimento por 7 cm de largura, onde as \ncaixas serão acomodadas de forma a caberem \ninteiramente dentro de cada prateleira. Além \ndisso, sabe-se que os carrinhos são cópias dos \nmodelos reais que possuem 387 cm de compri-\nmento por 172 cm de largura. \n \n \n \nQuantos carrinhos, no máximo, cabem em cada \numa das prateleiras? \n \n \nA) 2 \nB) 3 \n \nC) 9 \nD) 10 \nE) 7",
    "alternativas": {
      "E": "7",
      "A": "2",
      "B": "3",
      "C": "9"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 378,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0379",
    "numero": 1879,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Em um terreno, deseja-se instalar uma piscina \ncom formato de um bloco retangular de altura 1 \nm e base de dimensões 20 m x 10 m. Nas faces \nlaterais e no fundo desta piscina será aplicado \num líquido para a impermeabilização. Esse lí-\nquido deve ser aplicado na razão de 1 L para \ncada 1 m2 de área a ser impermeabilizada. O \nfornecedor A vende cada lata de impermeabili-\nzante de 10 L por R$ 100,00, e o B vende cada \nlata de 15 L por R$ 145,00. \n \nDetermine a quantidade de latas de impermea-\nbilizante que deve ser comprada e o fornecedor \na ser escolhido, de modo a se obter o menor \ncusto. \n \n \nA) Fabricante A, 46 latas. \nB) Fabricante B, 31 latas. \nC) Fabricante B, 17 latas. \nD) Fabricante B, 18 latas. \nE) Fabricante A, 26 latas.",
    "alternativas": {
      "E": "Fabricante A, 26 latas.",
      "B": "Fabricante B, 31 latas.",
      "C": "Fabricante B, 17 latas.",
      "D": "Fabricante B, 18 latas."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 379,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0380",
    "numero": 1880,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O Índice de Desenvolvimento Humano (IDH) \nmede a qualidade de vida dos países para além \ndos indicadores econômicos. O IDH do Brasil \ntem crescido ano a ano e atingiu os seguintes \npatamares: 0,600 em 1990; 0,665 em 2000; \n0,715 em 2010. Quanto mais perto de 1,00, \nmaior é o desenvolvimento do país. \n \nObservando o comportamento do IDH nos perí-\nodos citados, constata-se que, ao longo do pe-\nríodo 1990-2010, o IDH brasileiro: \n \n \nA) diminuiu em proporção direta com o tempo. \nB) aumentou em proporção direta com o tempo. \nC) aumentou com variações decenais decres-\ncentes. \nD) aumentou em proporção inversa com o tem-\npo. \nE) diminuiu com variações decenais crescentes.",
    "alternativas": {
      "D": "aumentou em proporção inversa com o tem- po.",
      "E": "diminuiu com variações decenais crescentes.",
      "B": "aumentou em proporção direta com o tempo.",
      "C": "aumentou com variações decenais decres- centes."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 380,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0381",
    "numero": 1881,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Vítor deseja revestir uma sala retangular de \ndimensões 3m x 4m, usando um tipo de peça de \ncerâmica. Em uma pesquisa inicial, ele selecio-\nnou cinco tipos de peças disponíveis, nos se-\nguintes formatos e dimensões: \n \n- Tipo I: quadrados, com 0,5m de lado. \n- Tipo II: triângulos equiláteros, com 0,5 m de lado. \n- Tipo III: retângulos, com dimensões 0,5m x 0,6m. \n- Tipo IV: triângulos retângulos isósceles, cujos \ncatetos medem 0,5m. \n- Tipo V: quadrados, com 0,6m de lado. \n \nAnalisando a pesquisa, o mestre de obras re-\ncomendou que Vítor escolhesse um tipo de piso \nque possibilitasse a utilização do menor número \nde peças e não acarretasse sobreposições ou \ncortes nas cerâmicas. \n \nQual o tipo de piso o mestre de obras recomen-\ndou que fosse comprado? \nA) Tipo II. \nB) Tipo IV. \n \nC) Tipo III. \nD) Tipo V. \nE) Tipo I.",
    "alternativas": {
      "E": "Tipo I.",
      "A": "Tipo II.",
      "C": "Tipo III.",
      "D": "Tipo V."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 381,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0382",
    "numero": 1882,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Um jovem lança uma bola de borracha para \nobservar sua trajetória e altura h (em metros) \natingida ao longo de um certo intervalo de tem-\npo t (em segundos). Nesse intervalo, a bola \nquica no chão algumas vezes, perdendo altura \nprogressivamente. Parte de sua trajetória está \ndescrita na figura a seguir. \n \n \n \nEm suas observações, quantas vezes o jovem \npôde constatar que a bola atingiu a marca de 35 \nmetros? \n \n \nA) Uma vez. \nB) Cinco vezes. \nC) Quatro vezes. \nD) Nenhuma. \nE) Duas vezes.",
    "alternativas": {
      "E": "Duas vezes.",
      "A": "Uma vez.",
      "B": "Cinco vezes.",
      "D": "Nenhuma."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 382,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0383",
    "numero": 1883,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma pizzaria oferece, no cardápio, duas opções \nde tamanhos e preços: \n \nPizza média (6 fatias): R$ 24,00 \n \nPizza grande (8 fatias): R$ 32,00 \n \nUm grupo de jovens estava prestes a decidir o \ntipo de pizza com melhor custo-benefício, quan-\ndo um dos amigos questionou ao garçom a res-\npeito do diâmetro de cada uma das pizzas. A \ninformação obtida foi de que os diâmetros das \npizzas média e grande eram, respectivamente, \n30 cm e 40 cm. Considerando que os dois ta-\nmanhos e preços das pizzas atendem o grupo e \nque não haverá desperdício, iniciou-se um de-\nbate entre eles: \n \n• Alan: A pizza grande tem melhor custo-\nbenefício, pois a área de sua fatia é superior à \nárea da fatia da pizza média. \n \n• Breno: A pizza média tem melhor custo-\nbenefício, pois, como é dividida em menos fati-\nas, cada fatia tem uma maior quantidade de \npizza. \n• Cleber: As duas apresentam a mesma relação \ncusto-benefício, já que cada fatia custa R$ 4,00, \nindependentemente da escolha do tamanho. \n \n• Davidson: Como a razão entre os diâmetros e \nos preços das pizzas é a mesma, nenhuma das \npizzas tem melhor custo-benefício que a outra. \n \n• Eric: A pizza grande possui melhor relação \ncusto benefício, pois, independentemente do \ndiâmetro, ela é dividida em um número maior de \nfatias. \n \nQual jovem apresentou o melhor argumento \npara a escolha da pizza? \n \n \nA) Cleber. \nB) Alan. \nC) Davidson. \nD) Eric. \nE) Breno.",
    "alternativas": {
      "A": "Cleber.",
      "B": "Alan.",
      "C": "Davidson.",
      "E": "Breno."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 383,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0384",
    "numero": 1884,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma prefeitura possui modelos de lixeira de \nforma cilíndrica, sem tampa, com raio medindo \n10 cm e altura de 50 cm. Para fazer uma com-\npra adicional, solicita à empresa fabricante um \norçamento de novas lixeiras, com a mesma \nforma e outras dimensões. A prefeitura só irá \nadquirir as novas lixeiras se a capacidade de \ncada uma for no mínimo dez vezes maior que o \nmodelo atual e seu custo unitário não ultrapas-\nsar R$ 20,00. O custo de cada lixeira é propor-\ncional à sua área total e o preço do material \nutilizado na sua fabricação é de R$ 0,20 para \ncada 100 cm2. A empresa apresenta um orça-\nmento discriminando o custo unitário e as di-\nmensões, com o raio sendo o triplo do anterior e \na altura aumentada em 10 cm.  \n \n(Aproxime 𝜋 para 3) \n \nO orçamento dessa empresa é rejeitado pela \nprefeitura, pois: \n \nA) o custo de cada lixeira ficou em R$ 32,40. \nB) o custo de cada lixeira ficou em R$ 21,60. \nC) capacidade de cada lixeira ficou 9 vezes \nmaior. \nD) o custo de cada lixeira ficou em R$ 27,00. \nE) a capacidade de cada lixeira ficou 3 vezes \nmaior.",
    "alternativas": {
      "A": "o custo de cada lixeira ficou em R$ 32,40.",
      "B": "o custo de cada lixeira ficou em R$ 21,60.",
      "C": "capacidade de cada lixeira ficou 9 vezes maior.",
      "D": "o custo de cada lixeira ficou em R$ 27,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 384,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0385",
    "numero": 1885,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Durante seu treinamento, um atleta percorre \nmetade de uma pista circular de raio R, confor-\nme figura a seguir. A sua largada foi dada na \nposição representada pela letra L, a chegada \nestá representada pela letra C e a letra A repre-\nsenta o atleta. O segmento LC é um diâmetro \nda circunferência e o centro da circunferência \nestá representado pela letra F. \nSabemos que, em qualquer posição que o atleta \nesteja na pista, os segmentos LA e AC são per-\npendiculares. Seja θ o ângulo que o segmento \nAF faz com segmento FC. \n \n \n \nQuantos graus mede o ângulo θ quando o seg-\nmento AC medir R durante a corrida? \n \nA) 90 graus. \nB) 30 graus. \nC) 120 graus. \nD) 15 graus. \nE) 60 graus.",
    "alternativas": {
      "C": "120 graus.",
      "D": "15 graus.",
      "E": "60 graus.",
      "B": "30 graus."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 385,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];